import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IntersectionObserverModule } from '@ng-web-apis/intersection-observer';

import { MotePipesModule } from '../../pipes';
import { SvgIconModule } from '../svg-icon';

import { ScheduleListComponent } from './schedule-list.component';

@NgModule({
    declarations: [ScheduleListComponent],
    imports: [
        CommonModule,
        IntersectionObserverModule,
        SvgIconModule,
        MotePipesModule
    ],
    exports: [
        ScheduleListComponent
    ]
})
export class ScheduleListModule { }
